<template>
  <div class="global-auth-box d-flex justify-center align-center" @click="show = false">
    <div class="g-auth-box" @click.stop>
      <div class="page-title">Redeem Promo Code</div>
      <div class="pax-field">
        <input type="text" placeholder="PROMO CODE" v-model="code" @keyup.enter="submit" />
      </div>
      <div class="error-msg" v-if="error">{{error}}</div>
      <div class="op-btn btn-md btn-block btn-success login-btn" @click="submit">SUBMIT</div>
      <div class="text-center">
        <a @click="show = false" href="javascript:;" class="cnl-btn">Cancel</a>
      </div>
    </div>
  </div>
</template>

<script>
import Credits from '@/modules/api/_credits'
import flightGroundQuote from '@/modules/api/flight-ground-quote'

export default {
  name: 'redeem-modal',
  data () {
    return {
      code: '',
      error: '',
      queue: []
    }
  },
  computed: {
    user () { return this.$store.state.user },
    redeem () { return this.$store.state.global.auth },
    show: {
      get () { return this.redeem.show },
      set (x) { this.$store.commit('global/setRedeemData', {show: x}) }
    },
    booking () { return this.$store.state.booking },
    filters () { return this.booking.filters },
    isReturning () { return this.filters.departure.isReturning },
    locations () { return this.booking.locations },
    selected () { return this.booking.selected },
    settings () { return this.booking.settings }
  },
  methods: {
    submit () {
      let self = this
      self.error = ''
      if (!self.code) {
        self.error = 'Enter promo code.'
        return
      }

      self.$store.commit('global/setLoaderData', {show: true})
      // self.$sdk.post(self, '/promo/redeem', {
      self.$sdk.post(self, '/discountcode/redeem', {
        deviceId: self.user.token,
        token: self.user.token,
        code: self.code
      }, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          if (r.error.message.slice(-1) === '.') r.error.message = r.error.message.substr(0, r.error.message.length - 1)
          self.error = self.$t(r.error.message)
          return
        }
        if (r.type === 'discount') {
          self.$store.commit('discountCode/setDiscountData', {
            id: r.data.id,
            code: r.data.code,
            type: r.data.type,
            amount: r.data.amount,
            start: r.data.start,
            end: r.data.end
          })
          self.requote()
          // self.error = self.$t('backend.Invalid promo code')
          return
        }

        Credits.get(self, {token: self.user.token}, () => {
          self.$store.commit('global/setLoaderData', {show: false})
          self.show = false
        })
      })
    },
    requote () {
      let self = this
      let selected = self.selected
      let leg1 = selected.leg1
      let leg2 = selected.leg2

      self.queue = []
      self.queue.push('pickupQuote')
      self.queue.push('dropoffQuote')
      if (self.isReturning && self.settings.customFlight) {
        if (leg1.flight[0].origin.AirportCode !== leg2.flight[leg2.flight.length - 1].destination.AirportCode) {
          self.queue.push('dropoffQuoteReturn')
        }
        if (leg1.flight[leg1.flight.length - 1].destination.AirportCode !== leg2.flight[0].origin.AirportCode) {
          self.queue.push('pickupQuoteReturn')
        }
      }
      self.processQueue()
    },
    processQueue () {
      if (this.queue[0] === 'pickupQuote') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getQuote('pickup', 'leg1')
        return
      }
      if (this.queue[0] === 'dropoffQuote') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getQuote('dropoff', 'leg1')
        return
      }
      if (this.queue[0] === 'pickupQuoteReturn') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getQuote('pickup', 'leg2')
        return
      }
      if (this.queue[0] === 'dropoffQuoteReturn') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getQuote('dropoff', 'leg2')
        return
      }
      this.$store.commit('global/setLoaderData', {show: false})
      this.show = false
    },
    getQuote (field, leg, extraData = null) {
      let self = this
      let pickupDate = this.filters.departure.date
      if (field === 'pickup') {
        pickupDate = this.selected[leg].flight[0].origin.DateTime
        pickupDate = pickupDate.split(' ')[0]
      } else {
        pickupDate = this.selected[leg].flight[this.selected[leg].flight.length - 1].destination.DateTime
        pickupDate = pickupDate.split(' ')[0]
      }
      let quoteData = {
        pickupDate: pickupDate,
        leg: leg,
        brandId: self.$store.state.brandId,
        order: 'priority',
        asap: false,
        d2dflight: 1,
        discountCode: self.$store.state.discountCode.code
      }
      let origin = field === 'pickup' ? self.locations.pickup : self.locations.dropoffAirport
      let destination = field === 'pickup' ? self.locations.pickupAirport : self.locations.dropoff
      if (leg === 'leg2') {
        origin = field === 'pickup' ? self.locations.dropoff : self.locations.dropoffAirportReturn
        destination = field === 'pickup' ? self.locations.pickupAirportReturn : self.locations.pickup
      }
      quoteData.pickup = {
        lat: origin.lat,
        lng: origin.lng
      }
      quoteData.dropoff = {
        lat: destination.lat,
        lng: destination.lng
      }

      flightGroundQuote.getQuote(self, field, leg, quoteData, res => {
        if (!res) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.queue = []
          return
        }
        self.queue.shift()
        self.processQueue()
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.global-auth-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0, .3);
  z-index: 2;
}
.g-auth-box{
  background: #f9f9f9;
  border-radius: 4px;
  box-shadow: 2px 2px 4px rgba(0,0,0, .3);
  padding: 20px;
  width: 100%;
  max-width: 400px;
}
.page-title{
  font-size: 21px;
  font-weight: 600;
  padding: 15px 0;
  text-align: center;
}
.pax-field{
  margin-bottom: 10px;

  input{
    padding: 10px;
    line-height: 1;
    box-shadow: inset 1px 1px 2px rgba(0,0,0,.1);
    border: 1px solid #ccc;
    width: 100%;
  }
  &.has-error{
    border:1px solid #EB5837;
  }
}
.forgot-box{
  text-align: left;
  color: #777;
  text-decoration: underline;

  span{
    cursor: pointer;
  }
}
.login-btn{
  margin: 20px 0;
}
.error-msg{
  border: 1px solid #f00;
  background: #fadfdf;
  color: #f00;
  padding: 5px;
  line-height: 1.3;
  border-radius: 2px;
  margin: 20px 0;
  text-align: left;

  a{
    color: #285cc7;
    font-weight: 600;
  }
}
.no-account{
  text-align: center;

  a{
    color: #ff9c09!important;
    font-weight: 600;
    cursor: pointer;
  }
}
.signup-btn{
  margin: 20px 0;
}

.cnl-btn{
  color: #888;
}
</style>



// WEBPACK FOOTER //
// RedeemModal.vue?ed79ae3e